var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55.8 56.1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.8 54.2c3.5 0 6.9-.7 10.1-2s6.1-3.3 8.6-5.7c2.5-2.5 4.4-5.4 5.7-8.6s2-6.6 2-10.1-.7-6.9-2-10.1-3.3-6.1-5.7-8.6c-2.5-2.5-5.4-4.4-8.6-5.7s-6.6-2-10.1-2z",
    fill: "#0b9fc4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m.6 52c3.3 1 6.8 1.3 10.3.9 3.4-.4 6.8-1.4 9.8-3.1s5.7-3.9 7.9-6.6 3.8-5.8 4.8-9.1 1.3-6.8.9-10.3c-.4-3.4-1.4-6.8-3.1-9.8s-3.9-5.7-6.6-7.9-5.8-3.8-9.1-4.8l-7.5 25.3z",
    fill: "#00d563"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.2 14c-.7-1.2-1.5-2.5-2.4-3.6v32.6c2.1-2.6 3.6-5.7 4.6-8.9 1-3.3 1.3-6.8.9-10.3-.4-3.4-1.4-6.8-3.1-9.8z",
    fill: "#12c6a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintain);
export default __webpack_public_path__ + "static/media/maintain.9f66b989c567cbbfd0c4443d17ee39f1.svg";
export { ForwardRef as ReactComponent };